import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { buildMainAppLoginUrl, silentCrossDomainAuth } from '@/lib/crossDomainAuth'
import { supabase } from '@/integrations/supabase/client'

export default function Login() {
  const { user, loading: authLoading } = useAuth()
  const navigate = useNavigate()
  const attempted = useRef(false)

  useEffect(() => {
    if (authLoading) return
    if (user) {
      navigate('/chat', { replace: true })
      return
    }

    if (attempted.current) return
    attempted.current = true

    // Try to silently inherit the session from the main Fluity app via a hidden
    // iframe + postMessage. If the user is already logged in there the tokens
    // arrive with no visible screen change.
    silentCrossDomainAuth().then(async (tokens) => {
      if (tokens) {
        const { error } = await supabase.auth.setSession(tokens)
        if (!error) {
          navigate('/chat', { replace: true })
          return
        }
      }
      // Not logged into main app → redirect to Fluity login (unchanged flow)
      window.location.replace(buildMainAppLoginUrl())
    })
  }, [authLoading, user, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-7 w-7 rounded-full border-[3px] border-muted border-t-primary animate-spin" />
    </div>
  )
}
